import { useTranslation } from "next-i18next"

const usePressLandingi18n = ({ authorData }) => {
  const { t } = useTranslation()
  const i18n = {
    title: t("kf.PressRoom.label.title"),
    description: t("kf.PressRoom.label.description"),
    pressContact: t("kf.PressRoom.label.pressContact"),
    productPlacement: t("kf.PressRoom.label.productPlacement"),
    contact1Name: t("kf.PressRoom.label.contact1Name"),
    contact1Email: t("kf.PressRoom.label.contact1Email"),
    contact1Mobile: t("kf.PressRoom.label.contact1Mobile"),
    contact2Name: t("kf.PressRoom.label.contact2Name"),
    contact2Email: t("kf.PressRoom.label.contact2Email"),
    contact2Mobile: t("kf.PressRoom.label.contact2Mobile"),
    productContact1Name: t("kf.PressRoom.label.productContact1Name"),
    productContact1Email: t("kf.PressRoom.label.productContact1Email"),
    productContact1Mobile: t("kf.PressRoom.label.productContact1Mobile"),
    productContact2Name: t("kf.PressRoom.label.productContact2Name"),
    productContact2Email: t("kf.PressRoom.label.productContact2Email"),
    productContact2Mobile: t("kf.PressRoom.label.productContact2Mobile"),
    print: t("kf.plp.label.print"),
    share: t("kf.plp.label.share"),
    sort: t("kf.plp.label.sort"),
    sortbyExpanded: t("kf.plp.label.sortbyExpanded"),
    sortbyClosed: t("kf.plp.label.sortbyClosed"),
    selected: t("kf.plp.arialabel.selected"),
    altSort: t("kf.plp.label.img.altSort"),
    date: t("kf.PressRoom.label.date"),
    pressKitTitle: t("kf.PressRoom.label.pressKitTitle"),
    description1: t("kf.PressRoom.label.description1"),
    viewPressKit: t("kf.PressRoom.label.viewPressKit"),
    externalLink: t("kf.PressRoom.label.externalLink"),
    accordianDetails: t("kf.PressRoom.label.accordianDetails"),
    downloadPdf: t("kf.PressRoom.label.downloadPdf"),
    pressReleaseTitle: t("kf.PressRoom.label.pressReleaseTitle"),
    readMore: t("kf.PressRoom.label.readMore"),
    download: t("kf.PressRoom.label.download"),
    downloading: t("kf.PressRoom.label.downloading"),
    sortByName: t("kf.PressRoom.label.sortByName"),
    sortByAsc: t("kf.PressRoom.label.sortByAsc"),
    sortByDesc: t("kf.PressRoom.label.sortByDesc"),
    sortByNewest: t("kf.PressRoom.label.sortByNewest"),
    sortByOldest: t("kf.PressRoom.label.sortByOldest"),
    pressRelease: t("kf.PressRoom.label.pressRelease"),
    pressKit: t("kf.PressRoom.label.pressKit"),
    imageLibrary: t("kf.PressRoom.label.imageLibrary"),
    cancel: t("kf.button.action.cancel"),
    ok: t("kf.button.action.ok"),
    modalHeading: t("kf.PressRoom.label.modalHeading"),
    modalContent: t("kf.PressRoom.label.modalContent"),
    viewMore: t("kf.PressRoom.label.viewMore"),
    showLess: t("kf.PressRoom.label.showLess"),
    noContacts: t("kf.PressRoom.label.noContacts"),
    noProducts: t("kf.PressRoom.label.noProducts"),
    loadMore: t("kf.plp.label.loadMore"),
    view: t("kf.plp.label.view"),
    all: t("kf.plp.label.all"),
    backToTop: t("kf.plp.label.backToTop"),
    items: t("kf.plp.label.items"),
    etc: t("kf.plp.label.etc"),
    sortByAria: count => t("kf.plp.label.sortByAria", { sortByCount: count }),
    ariaLabel: {
      downloadPdf: title => t("kf.PressRoom.aria.label.downloadPdf", { title }),
      loadMore: t("kf.pressRoom.aria.label.loadMore"),
      email: (email, name) =>
        t("kf.pressRoom.aria.label.email", { email, name }),
      phone: (phone, name) =>
        t("kf.pressRoom.aria.label.phone", { phone, name }),
      viewMore: t("kf.pressRoom.aria.label.viewMore"),
      viewLess: t("kf.pressRoom.aria.label.viewLess"),
      readMore: title => t("kf.PressRoom.aria.label.readMore", { title }),
      download: title => t("kf.PressRoom.aria.label.download", { title }),
      viewPressKit: title =>
        t("kf.PressRoom.aria.label.viewPressKit", { title }),
      externalLink: t("kf.PressRoom.aria.label.externalLink"),
    },
    downloadComplete: t("kf.PressRoom.label.downloadComplete"),
    complete: t("kf.PressRoom.label.complete"),
    downloadSuccess: t("kf.PressRoom.label.downloadSuccess"),
    downloadFailure: t("kf.PressRoom.label.downloadFailure"),
  }

  return i18n
}

export default usePressLandingi18n
